import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'ui-checkbox-wrapped',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule, FormsModule],
  templateUrl: './checkbox-wrapped.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxWrappedComponent {
  readonly checked = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly checkedChange = output<boolean>();

  onCheckboxChange(value: boolean): void {
    this.checkedChange.emit(value);
  }
}
